export class ToggleDropdown extends CustomEvent {
    /**
     * @param {HTMLElement} selectContainer
     * @param fromKeyboard
     */
    constructor(selectContainer, fromKeyboard = false) {
        super('toggledropdown');

        this.selectContainer = selectContainer;
        this.fromKeyboard = fromKeyboard;
    }
}

export class CloseDropdowns extends CustomEvent {
    /**
     * @param {boolean} restoreFocus
     */
    constructor(restoreFocus = false) {
        super('closedropdowns');

        this.restoreFocus = restoreFocus;
    }
}

export class DropdownOptionClicked extends CustomEvent {
    /**
     * @param {HTMLElement} selectContainer
     * @param {Element} option
     * @param fromKeyboard
     * @param key
     */
    constructor(selectContainer, option, fromKeyboard = false, key = null) {
        super('dropdownoptionclicked');

        this.selectContainer = selectContainer;
        this.option = option;
        this.fromKeyboard = fromKeyboard;
        this.key = key;
    }
}

export class RemoveMultiSelectChoice extends CustomEvent {
    /**
     * @param {HTMLElement} selectContainer
     * @param choice
     */
    constructor(selectContainer, choice) {
        super('removemultiselectchoice');

        this.selectContainer = selectContainer;
        this.choice = choice;
    }
}

export class SelectCleared extends CustomEvent {
    /**
     * @param {HTMLElement} selectContainer
     */
    constructor(selectContainer) {
        super('selectcleared', {bubbles: true});

        this.selectContainer = selectContainer;
    }
}

export class SelectOptionsChanged extends CustomEvent {
    /**
     * @param {HTMLElement} selectContainer
     */
    constructor(selectContainer) {
        super('selectoptionschanged');

        this.selectContainer = selectContainer;
    }
}

export class KeyboardNavigationStarted extends CustomEvent {
    /**
     * @param {HTMLElement} selectContainer
     */
    constructor(selectContainer) {
        super('keyboardnavigationstarted');

        this.selectContainer = selectContainer;
    }
}

export class ToggleAllOptions extends CustomEvent {
    /**
     * @param {boolean} checked
     */
    constructor(checked) {
        super('togglealloptions');

        this.checked = checked;
    }
}
